/**
 * CLARTEXT · A1 (Feb 2026) — Aushangpflicht-Anzeige · Owner-Seite.
 *
 * Rein listende Owner-Sicht. Lädt `/api/owner/aushang`. Erreichbar über
 * die Sidebar (`nav-aushang`) sowie die bestehende Dashboard-Kachel.
 */
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import AushangList from "@/components/AushangList";

export default function AushangPflicht() {
  const [data, setData] = useState(null);
  const [forbidden, setForbidden] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    let cancelled = false;
    api
      .getOwnerAushang()
      .then((res) => {
        if (!cancelled) setData(res);
      })
      .catch((err) => {
        if (cancelled) return;
        const status = err?.response?.status;
        if (status === 403) setForbidden(true);
        else setErrorMsg("Aushang konnte nicht geladen werden.");
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="max-w-4xl mx-auto space-y-6" data-testid="aushang-pflicht-page">
      <div>
        {/* MODUL-REITER-02, Betreiberfreigabe 29.10.2026: Schreibweise „Aushangpflichtige“. */}
        <p className="text-xs uppercase tracking-widest text-slate-500 font-medium">
          Aushangpflichtige Gesetze
        </p>
        <h1 className="font-heading text-3xl sm:text-4xl font-bold text-slate-900 mt-2">
          Aushangpflichtige Gesetze und Vorschriften
        </h1>
        <p className="text-slate-600 mt-2">
          Verlinkte, amtliche Originaltexte. Diese Liste wird zentral gepflegt
          und ist für alle Mitarbeitenden Ihres Betriebs sichtbar.
        </p>
      </div>

      {forbidden ? (
        // MODUL-REITER-02, Betreiberfreigabe 29.10.2026: Hinweis „nicht gebucht“ mit Knopf „Hinzubuchen“.
        <div
          className="border border-amber-200 bg-amber-50 text-amber-900 rounded-md p-4 text-sm flex flex-wrap items-center justify-between gap-3"
          data-testid="aushang-pflicht-forbidden"
        >
          <span>Dieses Zusatzmodul ist für Ihren Betrieb nicht gebucht.</span>
          <a
            href="/unternehmer/einstellungen#zusatzmodule"
            className="inline-flex items-center rounded-md bg-slate-900 px-4 py-2 text-sm font-medium text-white hover:bg-slate-800 transition-colors"
            data-testid="aushang-hinzubuchen-link"
          >
            Hinzubuchen
          </a>
        </div>
      ) : errorMsg ? (
        <div
          className="border border-red-200 bg-red-50 text-red-900 rounded-md p-4 text-sm"
          data-testid="aushang-pflicht-error"
        >
          {errorMsg}
        </div>
      ) : (
        // Owner-UI bleibt zwingend deutsch — unabhängig von einer etwaigen
        // Monteur-Session im selben Browser (forcedLang-Muster).
        <AushangList data={data} forcedLang="de" />
      )}
    </div>
  );
}
